import {ReactElement} from 'react';
import {Link} from '@shopify/hydrogen';
import {NavigationLinkType} from '../../types';
import VectorIcon from '../VectorIcon';
import classNames from 'classnames';

interface NavigationMenuListColumnProps {
  title: string;
  links: ReadonlyArray<NavigationLinkType>;
  onNavigate: () => void;
}

export default function NavigationMenuListColumn({
  title,
  links,
  onNavigate,
}: NavigationMenuListColumnProps): ReactElement {
  return (
    <div className="submenu__top-col">
      <h3 className="submenu__top-title">{title}</h3>
      <ul className="submenu__top-list">
        {links?.map((link) => (
          <li
            key={`${link.link_label}${link.link}`}
            className="submenu__top-item"
          >
            <Link
              to={link.link}
              target={link.link_target}
              className={classNames('submenu__top-link', {
                'submenu__top-link__country': link.link_type === 'country',
              })}
              onClick={onNavigate}
            >
              {link.link_type === 'country' ? (
                <>
                  <VectorIcon iconName={link.country_icon} />
                  <span>{link.link_label}</span>
                </>
              ) : (
                link.link_label
              )}
              {link.link_tag && (
                <span className="submenu__top-tag tag-element">
                  {link.link_tag}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
